

<template>
    <div class="report user-month">

        <h1>Time report</h1>

        <b-row>
            <b-col cols="3">
                <b-form-group
                    label="Year">
                    <select-box :options="years" v-model="selected.year"
                                 placeholder="Year"
                                 :multiple="false"
                                 :allow-empty="false"
                                 @input="updateReport"
                    ></select-box>
                </b-form-group>
            </b-col>
            <b-col cols="3">
                <b-form-group label="Month">
                    <select-box :options="$get('system/getMonths')"
                                 v-model="selected.month"
                                 placeholder="Month"
                                 :multiple="false"
                                 @input="updateReport"
                                 :allow-empty="false"
                    ></select-box>
                </b-form-group>
            </b-col>

            <b-col cols="3">
                <b-form-group
                    label="Date">
                    <select-box :options="daysList"
                                 v-model="selected.day"
                                 placeholder="Month"
                                 :multiple="false"
                                 @input="updateReport"
                                 :allow-empty="false"
                    ></select-box>
                </b-form-group>
            </b-col>
        </b-row>

        <h2>Hours by people
            <span class="download" @click="$api.download_table_as_csv('user-d-report', ';')">[Download data]</span>
        </h2>
        <b-table class="user-d-report" striped hover :items="reportData" @row-clicked="showUserReport" :fields="['user_name', 'hours'].concat($get('auth/checkCurrentRoleInList', ['finance']) ? ['payout', 'user_rate_currency', 'user_payment_method'] : [])"></b-table>

        <h2>
            Hours by projects
            <span class="download" @click="$api.download_table_as_csv('proj-d-report', ';')">[Download data]</span>
        </h2>
        <b-table class="proj-d-report"  striped hover :items="reportProjs" :fields="['project_title', 'hours'].concat($get('auth/checkCurrentRoleInList', ['finance']) ? ['payout', 'user_rate_currency'] : [])"></b-table>

    </div>
</template>

<script>
    import SelectBox from "../../components/SelectBox";

    export default {

        components: {
            SelectBox,
        },

        // Properties
        props: ["user_id"],

        data() {
            return {
                // Chart data
                years: [],
                selected: {
                    month: '',
                    day: 0,
                    year: 2019,
                },

                reportData: [],
                reportProjs: []
            }
        },

        computed: {


            /**
             * Get current user obj
             */
            currentUser() {
                return this.$store.getters['auth/currentUser'];
            },


            /**
             * Days list
             */

            daysList()
            {

                // Days
                let days = [{id: 0, title: "All"}];

                // Full days
                Array.from(Array(new Date(this.selected.year, this.selected.month, 0).getDate()).keys()).map(n => {
                    days.push({id: n+1, title: n+1});
                });

                // Return days
                return Object.values(days);
            },

            /**
             * Dates
             */

            dates() {
                // Return dates
                return this.$api.pluck(this.reportData, 'date');
            },

            /**
             * Hours
             */

            hours() {
                // Return hours
                return [{
                    label: 'Hours',
                    backgroundColor: '#aaf',
                    data: this.$api.pluck(this.reportData, 'hours')
                }];
            },
        },

        // Mounted items
        mounted() {

            // Define initial params
            this.selected.day = new Date().getDate();
            this.selected.month = new Date().getMonth() + 1;
            this.selected.year = new Date().getFullYear();
            this.years = [];
            Array.from(Array(11).keys()).map(n => {
                this.years.push({id: 2019+n, title: 2019+n});
            });

            // Load report
            this.updateReport();
        },

        // Methods list
        methods: {

            /**
             * Show users report
             */

            showUserReport(row)
            {
                // Open users report
                this.$router.push({name:"user-report-details", params: {month:parseInt(this.selected.month), year:this.selected.year, day: this.selected.day,  user_id: row.user_id}});
            },

            /**
             * Update report
             */
            updateReport() {

                // Reset data
                this.reportData = [];

                // Load report for user
                this.$dispatch("timelog/loadUsersMonthReport", {
                    user_id: this.user_id,
                    month: parseInt(this.selected.month),
                    year: this.selected.year,
                    day: this.selected.day
                }).then((data) => {
                    // Store current report
                    this.reportData = data;
                });

                // Reset data
                this.reportProjs = [];

                // Load report for user
                this.$dispatch("timelog/loadUsersProjectsReport", {
                    user_id: 0,
                    month: parseInt(this.selected.month),
                    year: this.selected.year,
                    day: this.selected.day
                }).then((data) => {
                    // Store current report
                    this.reportProjs = data;
                });



            }
        }
    }

</script>


<style lang="scss">

    .report {
        padding: 10px;
        .totals {margin-top:10px;}

        .download {
            font-size:12px;
            text-decoration: underline;
            cursor: pointer;
        }
    }

</style>
